import { render, staticRenderFns } from "./dongtaixinwen.vue?vue&type=template&id=0bc2d110&scoped=true&"
import script from "./dongtaixinwen.vue?vue&type=script&lang=js&"
export * from "./dongtaixinwen.vue?vue&type=script&lang=js&"
import style0 from "./dongtaixinwen.vue?vue&type=style&index=0&id=0bc2d110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2d110",
  null
  
)

export default component.exports